import { useEventProvider } from '@/helpers/event-context';
import { useLanding } from '../Landings/LandingProvider/LandingProvider';
import { GeoLocationResult } from '../Landings/utils/geoVideo/types';

import styles from '@/src/containers/Home/Home.module.scss';

import FeaturesSection from '@/src/containers/Home/components/FeaturesSection';
import JoinSection from '@/src/containers/Home/components/JoinSection';
import BrandedContent from '@/src/containers/Home/components/BrandedContent';
import StopWastingTimeSection from '@/src/containers/Home/components/StopWastingTimeSection';
import DifferentIndustry from '@/src/containers/Home/components/DifferentIndustry';
import LandingStats from '@/src/containers/Landings/LandingStats';
import Testimonial from '@/src/containers/Landings/Testimonial';
import Reviews from '@/src/containers/Landings/Reviews';
import AsSeenSection from '@/src/containers/Landings/AsSeenSection';
import { GetStartedSection } from '@/src/containers/Home/components/GetStartedSection';
import HomeHeader from '@/src/shared/components/HomeHeader';
import dynamic from 'next/dynamic';

const RegistrationPopup = dynamic(
  () => import('@/src/containers/RegistrationPopup')
);

type Props = GeoLocationResult;

export const HomeContent = ({
  usersCount,
  video,
  regions,
  detectedRegion,
  default_region_name,
  ip_location_details,
}: Props) => {
  const { closeRegistrationPopup, isRegistrationPopupOpen } = useLanding();
  const { getPageName } = useEventProvider();

  return (
    <>
      <div className={styles.container}>
        <HomeHeader bgColor="transparent" />
        <GetStartedSection />
        <JoinSection numberOfUsers={usersCount} />
        <BrandedContent />
        <StopWastingTimeSection />
        <DifferentIndustry />
        <FeaturesSection />
        <LandingStats />
        <Testimonial />
        <Reviews />
        <AsSeenSection />
      </div>

      {isRegistrationPopupOpen && (
        <RegistrationPopup
          key="register-popup"
          source={getPageName()}
          open
          title="Get Your Free Video"
          onClose={() => closeRegistrationPopup()}
          regions={regions}
          defaultRegion={default_region_name || detectedRegion}
          phoneCountryCode={ip_location_details?.country?.toLowerCase()}
          ctaLabel="Get Free Videos"
          videoId={video?.id}
          section="city_form"
          regionInputType="location-selector"
          defaultLocation={{
            userRegionName: ip_location_details.region,
            userCityName: ip_location_details.city,
            userRegionFBKey: null,
          }}
        />
      )}
    </>
  );
};
